import React, { Component } from 'react';
import autoBind from 'react-autobind';
import { withTranslation } from 'react-i18next';
import composeModalActions from 'src/utils/modal-action-wrapper';
import { List, ListItem, makeSelectable } from 'material-ui/List';
import HomeIcon from 'material-ui/svg-icons/action/home';
import { blue700, green700, red400 } from 'material-ui/styles/colors';
import OpenFolderIcon from 'material-ui/svg-icons/file/folder-open';
import ClosedFolderIcon from 'material-ui/svg-icons/file/folder';
import BootstrapTableErrorBoundary from 'src/components/error/BootstrapTableErrorBoundary';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import moment from 'moment';
import { asyncRequest, Entities, TOMCAT_URL } from 'src/common';
import LabelIcon from 'material-ui/svg-icons/action/label';
import BusRequestDetailsModal from 'src/components/administration/bus-request/components/bus-request-details-modal';
import { ContentArchive } from 'material-ui/svg-icons';
import Divider from 'material-ui/Divider';
import BusRequestArchiveModalAdmin from 'src/components/admin/bus-requests/components/bus-request-archive-modal-admin';

let SelectableList = makeSelectable(List);

export const busRequestAdministrationFilterMappings = t => ({
    MY_BUS_REQUESTS: {
        filter: 'MY_BUS_REQUESTS',
        title: t('bus_requests.filter.all'),
    },
    NO_OFFER_CREATED: {
        filter: 'NO_OFFER_CREATED',
        title: t('bus_requests.filter.offer_missing'),
    },
    OFFER_CREATED: {
        filter: 'OFFER_CREATED',
        title: t('bus_requests.filter.offer_created'),
    },
    RESULTED_BOOKINGS: {
        filter: 'RESULTED_BOOKINGS',
        title: t('bus_requests.filter.customer_booked'),
    },
    DECLINED_OFFERS: {
        filter: 'DECLINED_OFFERS',
        title: t('bus_requests.filter.offer_declined'),
    },
    IS_ARCHIVED: {
        filter: 'IS_ARCHIVED',
        title: t('bus_requests.filter.archive'),
    },
});

class BusRequestAdmin extends Component {
    constructor(props) {
        super(props);
        autoBind(this);
        const query = props.location.query;
        const { t } = props;
        const currentFilterMapping =
            query && query.filter
                ? busRequestAdministrationFilterMappings(t)[query.filter]
                : busRequestAdministrationFilterMappings(t).MY_BUS_REQUESTS;
        this.state = {
            filter: currentFilterMapping,
            tableTitle: currentFilterMapping.title,
        };
    }

    componentWillMount() {
        this.props.findOwnedByBusfinderIntegrationBusRequests(this.state.filter.filter);
    }

    render() {
        const { t, busRequests } = this.props;
        const filterMapping = busRequestAdministrationFilterMappings(t);
        const tableData = [];

        if (!busRequests.isFetching) {
            busRequests.items.map(busRequest => {
                tableData.push({
                    id: busRequest.id,
                    createdAt: busRequest.createdAt,
                    from: busRequest.from,
                    to: busRequest.to,
                    pax: busRequest.pax,
                    returnTrip: busRequest.returnTrip,
                    intermediates: busRequest.intermediates,
                    customer: busRequest.customerContactData,
                    booking: busRequest.booking,
                    customerComment: busRequest.customerComment,
                    returnTripDate: busRequest.returnTripDate,
                    isArchived: busRequest.archived,
                    identifier: busRequest.identifier,
                });
            });
        }
        return (
            <div className="row">
                <div className="col-md-2 sidebar-listview">{this.renderFilterMapping()}</div>
                <div id="tasklist-panel" className="col-md-10">
                    <legend className="legend">{t(this.state.tableTitle)}</legend>
                    <BootstrapTableErrorBoundary>
                        <BootstrapTable ref={ref => (this.table = ref)} data={tableData}>
                            <TableHeaderColumn columnTitle={true} width="10" dataField="id" isKey={true} export={true}>
                                {t('common_phrases.id')}
                            </TableHeaderColumn>
                            <TableHeaderColumn columnTitle={true} dataField="pax" dataSort={true} width="20">
                                {t('search_requests.pax')}
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                columnTitle={true}
                                dataField="from"
                                dataSort={true}
                                width="30"
                                dataFormat={this.dateFormatter}
                                csvFormat={this.dateFormatter}>
                                {t('search_requests.from.time')}
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                columnTitle={true}
                                dataField="from"
                                width="50"
                                dataFormat={this.locationInfo}
                                csvFormat={this.locationInfo}>
                                {t('search_requests.from.title')}
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                columnTitle={true}
                                dataField="to"
                                width="50"
                                dataFormat={this.locationInfo}
                                csvFormat={this.locationInfo}>
                                {t('search_requests.to.title')}
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                columnTitle={true}
                                dataField="intermediates"
                                width="20"
                                dataFormat={(cell, row) => {
                                    const count = cell.length + (row.returnTrip ? 1 : 0);
                                    return count > 0 ? count : '-';
                                }}
                                csvFormat={(cell, row) => {
                                    const count = cell.length + (row.returnTrip ? 1 : 0);
                                    return count > 0 ? count : '-';
                                }}>
                                {t('search_requests.intermediateCount')}
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                columnTitle={true}
                                dataField="customer"
                                width="80"
                                dataFormat={cell => cell.email}
                                csvFormat={cell => cell.email}>
                                Customer mail
                            </TableHeaderColumn>
                            {/*<TableHeaderColumn*/}
                            {/*    columnTitle={true}*/}
                            {/*    dataField="booking"*/}
                            {/*    width="20"*/}
                            {/*    dataFormat={this.requestStatus}*/}
                            {/*    csvFormat={this.requestStatus}>*/}
                            {/*    Status*/}
                            {/*</TableHeaderColumn>*/}
                            <TableHeaderColumn
                                dataField="actions"
                                width="90"
                                dataFormat={this.tableActionsFormatter}
                                export={false}>
                                {t('common_phrases.actions')}
                            </TableHeaderColumn>
                        </BootstrapTable>
                    </BootstrapTableErrorBoundary>
                </div>
            </div>
        );
    }

    tableActionsFormatter = (_cell, request) => {
        const { t } = this.props;
        return (
            <div>
                <button
                    type="button"
                    className="btn btn-xs transparent"
                    title={t('user_functionality.create_offer')}
                    onClick={() => {
                        asyncRequest(`${TOMCAT_URL}api/${Entities.BUS_REQUESTS.repository}/create-link/${request.id}`)
                            .then(response => {
                                const json = response.json;
                                if (json && json.url) {
                                    const win = window.open(json.url, '_blank');
                                    if (win != null) win.focus();
                                }
                            })
                            .catch(error => console.error('Error creating Link', error));
                    }}>
                    <span className="glyphicon glyphicon-new-window text-info" />
                </button>
                <button
                    type="button"
                    className="btn btn-xs transparent"
                    title={t('search_requests.display_details')}
                    onClick={() => {
                        this.props.openModal({
                            component: BusRequestDetailsModal,
                            componentProps: {
                                busRequest: request,
                            },
                            title: t('bus_requests.modal.title'),
                            mandatoryFields: false,
                            noButtons: true,
                        });
                    }}>
                    <span className="fa fa-info-circle text-info" />
                </button>
                {!request.isArchived && (
                    <button
                        type="button"
                        className="btn btn-xs transparent"
                        title={t('bus_requests.archive_request')}
                        onClick={() => {
                            this.props.openModal({
                                component: BusRequestArchiveModalAdmin,
                                componentProps: {
                                    busRequest: request,
                                    filter: this.state.filter.filter,
                                    findOwnedByBusfinderIntegrationBusRequests:
                                        this.props.findOwnedByBusfinderIntegrationBusRequests,
                                },
                                successButtonLabel: t('bus_requests.archive_request'),
                                title: request.identifier,
                            });
                        }}>
                        <span className="fa fa-archive text-info" />
                    </button>
                )}
            </div>
        );
    };

    dateFormatter(cell, row) {
        return cell ? `${moment(cell.time).format()}` : '-';
    }

    renderFilterMapping() {
        const { t } = this.props;
        const filterMapping = busRequestAdministrationFilterMappings(t);

        return (
            <SelectableList
                selectedItemStyle={{
                    backgroundColor: '#0a71ba1a',
                }}
                value={this.state.filter}
                onChange={() => this}>
                <ListItem
                    className="styled-list-item"
                    key={0}
                    value={filterMapping.MY_BUS_REQUESTS.filter}
                    primaryText={t('bus_requests.filter.all')}
                    leftIcon={<HomeIcon color={blue700} />}
                    onClick={() => this.changeFilter(filterMapping.MY_BUS_REQUESTS)}
                />
                {/*<ListItem*/}
                {/*    className="styled-list-item"*/}
                {/*    key={1}*/}
                {/*    value={filterMapping.NO_OFFER_CREATED.filter}*/}
                {/*    primaryText={t('bus_requests.filter.offer_missing')}*/}
                {/*    leftIcon={<OpenFolderIcon color={red400} />}*/}
                {/*    onClick={() => this.changeFilter(filterMapping.NO_OFFER_CREATED)}*/}
                {/*/>*/}
                {/*<ListItem*/}
                {/*    className="styled-list-item"*/}
                {/*    key={2}*/}
                {/*    value={filterMapping.OFFER_CREATED.filter}*/}
                {/*    primaryText={t('bus_requests.filter.offer_created')}*/}
                {/*    leftIcon={<ClosedFolderIcon color={blue700} />}*/}
                {/*    onClick={() => this.changeFilter(filterMapping.OFFER_CREATED)}*/}
                {/*/>*/}
                {/*<ListItem*/}
                {/*    className="styled-list-item"*/}
                {/*    key={3}*/}
                {/*    value={filterMapping.RESULTED_BOOKINGS.filter}*/}
                {/*    primaryText={t('bus_requests.filter.customer_booked')}*/}
                {/*    leftIcon={<LabelIcon color={green700} />}*/}
                {/*    onClick={() => this.changeFilter(filterMapping.RESULTED_BOOKINGS)}*/}
                {/*/>*/}
                <Divider />
                <ListItem
                    className="styled-list-item"
                    key={4}
                    value={filterMapping.IS_ARCHIVED.filter}
                    primaryText={t('bus_requests.filter.archive')}
                    leftIcon={<ContentArchive color={blue700} />}
                    onClick={() => this.changeFilter(filterMapping.IS_ARCHIVED)}
                />
            </SelectableList>
        );
    }

    requestStatus(request) {
        const { t } = this.props;
        if (request == null || request.offerDetails == null)
            return (
                <span title={t('bus_requests.filter.offer_missing')}>
                    <OpenFolderIcon color={red400} />
                </span>
            );
        if (request.offerDetails.offerStatus === 'OPEN')
            return (
                <span title={t('bus_requests.filter.offer_created')}>
                    <ClosedFolderIcon color={blue700} />
                </span>
            );
        if (request.offerDetails.offerStatus === 'ACCEPTED')
            return (
                <span title={t('bus_requests.filter.customer_booked')}>
                    <LabelIcon color={green700} />
                </span>
            );
    }

    locationInfo(locationAndTime) {
        return `${locationAndTime.location.address}`;
    }

    changeFilter(changedFilterMapping) {
        const { selectedCompany } = this.props;

        this.props.push(`/admin/bus-requests?filter=${changedFilterMapping.filter}`);
        this.props.findOwnedByBusfinderIntegrationBusRequests(changedFilterMapping.filter);
        this.setState({
            filter: changedFilterMapping.filter,
            tableTitle: changedFilterMapping.title,
        });
    }
}

export default withTranslation()(composeModalActions(BusRequestAdmin));
